import React, { useEffect } from 'react';
import SearchIcon from './search-icon';

export interface LogEventType {
  eventName: string;
  eventParams: Record<string, any>
}

interface SearchAnchorPropType {
  dataType: string;
  dataWord: string;
  dataRegion: string;
  dataId: string;
  onSearchAnchorClick: (word: string) => void;
  onLogEvent: (data: LogEventType) => void;
};

export const SearchAnchorItem: React.FC<SearchAnchorPropType> = props => {

  const { dataType, dataWord, dataRegion, dataId, onLogEvent, onSearchAnchorClick } = props;
  const discoverPath = `/discover/${dataWord}`;
  const discoverHref = `${discoverPath}?region=${dataRegion}`;

  const handleItemClick = (e: any) => {
    e.preventDefault();
    onSearchAnchorClick(dataWord);
    onLogEvent({eventName: 'wap_click', eventParams:{current_position: 'main_search_word'}});
  };

  return (
    <a
      onClick={handleItemClick}
      key={`search-${dataId}`}
      href={discoverHref}
      className="l8-entity-word"
    >
      <span className="l8-entity-word-name">{dataWord}</span>
      <SearchIcon />
    </a>
  );
};
